export class ChoosePlanState {  
    setPlan():void {}
}

